/**
 * @deprecated
 */
'use strict';

class customFieldService {
  obj2arr(obj) {
    let arr = [];
    obj.map((item) => arr.push('' + item.value));

    return arr;
  }

  arr2obj(arr) {
    return arr.map((item) => {
      return {
        number: arr.indexOf(item) + 1,
        value: item
      };
    });
  }

  clean(obj) {
    if (obj && obj.name) {
      return {
        name: obj.name,
        type: obj.type !== 'ENUM' ? obj.type : 'TEXT',
        options: $.isArray(obj.options) ? this.obj2arr(obj.options) : null,
        required: obj.required
      };
    } else {
      return {
        name: null
      };
    }
  }

  isDuplicate(obj1, obj2) {
    for (let i = 0; i < obj1.length; i++) {
      if (obj1[i].name === this.clean(obj2).name) {
        return false;
      }
    }

    return true;
  }
}

angular
  .module('SendRegning')
  .service('customFieldService', customFieldService);
